import React from 'react'
import TransitionLink from 'gatsby-plugin-transition-link'

export default function Link (obj) {
  return (
    <TransitionLink {...obj} entry={{ delay: 0.3 }} />
  )
}
